import { IEnvironment } from './i-environment';

// app environment variables
const APP_CODE = `bnpp-indx`;
const APP_BASE_API = `/api/bnpp-indx`;

// sdpp web environment variables
const SDPP_WEB_AG_GRID_LICENSE = `Using_this_{AG_Grid}_Enterprise_key_{AG-118207}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{BNP_Paribas_CIB_ITO_-_GB_IT_-_PCM}_is_granted_a_{Multiple_Applications}_Developer_License_for_{10}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{26_January_2027}____[v3]_[01]_MTgwMDkyMTYwMDAwMA==f2b66049a1cf966531d972ce7b94006d`;

export const environment: IEnvironment = {
  production: true,
  agGridLicenseKey: SDPP_WEB_AG_GRID_LICENSE,
  appCode: APP_CODE,
  baseIndxApi: APP_BASE_API,
};
